export default __webpack_public_path__ + "static/graphql-387b2df926aee7653a5690b2c7e94b3f.svg";